import React, { useState } from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { routes } from 'constants/config';
import { Button, ButtonGroup, Icon } from 'ui';
import request from 'utils/request_ajax';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

const JourneyCreationModal = ({ closeModal }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const createJourney = () => {
    request
      .postJSON(routes.JOURNEY.CREATE, {
        title,
        description,
      })
      .then(response => {
        const journeyUrl = routes.JOURNEY.EDIT(response.id);
        window.location.assign(journeyUrl);
      })
      .fail(() => {});
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    createJourney();
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container JourneyCreationModal">
          <div className="JourneyCreationModal-body">
            <form onSubmit={handleSubmit}>
              <div className="JourneyCreationModal-title">
                {t('journeys.create_modal.new_journey')}
              </div>
              <div className="JourneyCreationModal-subtitle">
                {t('journeys.create_modal.description')}
              </div>
              <label
                htmlFor="title"
                className="JourneyCreationModal-inputTitle"
              >
                {t('common.title') + ' *'}
              </label>
              <input
                id="title"
                name="title"
                className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                placeholder={t('common.enter_title')}
                type="text"
                onChange={e => setTitle(e.target.value)}
                value={title}
                maxLength="255"
              />
              <label
                htmlFor="description"
                className="JourneyCreationModal-inputTitle"
              >
                {t('common.description')}
              </label>
              <textarea
                id="description"
                name="description"
                className="NewInput NewInput--white NewInput--fw"
                placeholder={t('common.enter_description')}
                rows="3"
                onChange={e =>
                  setDescription(e.target.value.replace(/\r?\n|\r/g, ' '))
                }
                onKeyDown={preventLineBreaks}
                value={description}
              />
              <ButtonGroup alignEnd className="mt-32">
                <Button
                  customColor
                  type="submit"
                  loading={loading}
                  disabled={title.length === 0}
                >
                  {t('journeys.create_modal.create_journey')}
                </Button>
              </ButtonGroup>
            </form>

            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default JourneyCreationModal;
